import { takeEvery, put } from "redux-saga/effects";
import api from "../../../utils/apiService";
import { ENDPOINT } from "../../../config/endpoints";
import {
  getQueries,
  getQueriesSuccess,
  submitQuery,
  submitQuerySuccess,
  getQueriesByTicketId,
  getQueriesByTicketIdSuccess,
  getQueriesLimit,
  getQueriesLimitSuccess,
  getZohoUser,
  getZohoUserSuccess,
} from "../../slices/SupportSlice";

/**
 * Uplifted from `redux-store/saga/support` (apps/web + apps/mobile).
 *
 * `shared.ts` OWNS it: the two apps are IDENTICAL in logic. The raw diff looked large (51 lines)
 * but every one was formatting — quote style, trailing commas, indentation, one blank line, and
 * a commented-out `//url: "http://localhost/..."` that only web carries. Same five workers, same
 * endpoints, same actions, same order in `root`.
 *
 * ⚠️ Bare folder imports are REQUIRED in a `shared.ts` (hazard 16).
 *
 * Dropped under standing rule 2(b): BOTH apps imported `take` from `redux-saga/effects` and
 * neither referenced it (0 uses on both sides). `put` is used 5× on both and stays.
 *
 * The `console.log`s are preserved verbatim — they are the file's existing behaviour, and web's
 * prod build strips them anyway (`babel-plugin-transform-remove-console`).
 */
function* fetchQueries(action: any): Generator<any, void, any> {
  console.log("getUsersInfo!!");
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.SUPPORT.getQuery(),
      data: payload,
    });
    console.log("response ticket Created: ", response);
    yield put(getQueriesSuccess(response));
  } catch (error) {
    console.log("error", error);
  }
}

function* fetchQueriesById(action: any): Generator<any, void, any> {
  console.log("getUsersInfo!!");
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.SUPPORT.getQueryByZohoId(action.payload),
      data: payload,
    });
    console.log(" ticket Updated: ", response);
    yield put(getQueriesByTicketIdSuccess(response));
  } catch (error) {
    console.log("error", error);
  }
}

function* postQuery(action: any): Generator<any, void, any> {
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.SUPPORT.postQuery(),
      data: payload,
    });
    console.log("response sendRegistrationKey: ", response);

    yield put(submitQuerySuccess(response));
  } catch (error) {
    console.log("error", error);
  }
}

function* fetchQueriesLimit(action: any): Generator<any, void, any> {
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.SUPPORT.getQueryLimit(),
      data: payload,
    });
    yield put(getQueriesLimitSuccess(response));
  } catch (error) {
    console.log("error", error);
  }
}

function* fetchZohoUser(action: any): Generator<any, void, any> {
  console.log("getUsersInfo!!");
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.SUPPORT.getZohoUser(),
      data: payload,
    });
    console.log(" zoho user: ", response);
    yield put(getZohoUserSuccess(response));
  } catch (error) {
    console.log("error", error);
  }
}

export default function* root() {
  yield takeEvery(getQueries.type, fetchQueries);
  yield takeEvery(submitQuery.type, postQuery);
  yield takeEvery(getQueriesByTicketId.type, fetchQueriesById);
  yield takeEvery(getQueriesLimit.type, fetchQueriesLimit);
  yield takeEvery(getZohoUser.type, fetchZohoUser);
}
